module.exports = __webpack_public_path__ + "static/media/IPRO.c04cd41b.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/images/books/IPRO.jpg
// module id = 1354
// module chunks = 1